import React from 'react';
import styles from './RelatedStories.module.scss';
import { RelatedArticle } from 'model/Article';
import classNames from 'classnames';
import { useCalculatedArticleFields } from 'hooks/useCalculatedArticleField';
import { ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-nextjs';

export type RelatedStoriesProps = {
  articles?: RelatedArticle[];
  rendering: ComponentRendering<{ baseUrl: Field<string> }>;
  title: string;
  isExperienceEditor?: boolean;
  className?: string;
  baseUrl?: string;
};

const RelatedStories: React.FC<RelatedStoriesProps> = ({
  articles = [],
  rendering,
  title,
  isExperienceEditor = false,
  className,
  baseUrl,
}) => {
  const id = title.toLowerCase().replace(/\s+/g, '-');
  const { getUrl } = useCalculatedArticleFields();
  return (
    (articles.length > 0 || isExperienceEditor) && (
      <div
        id={id}
        data-e2e-component-uid={rendering.uid}
        className={classNames(styles.relatedStories, className)}
      >
        <h5 className="mb-3">{title}</h5>
        <div className={`px-3 ${styles.relatedStoriesListing} background-digital-light-grey`}>
          {articles.map((article) => (
            <div key={article.id} className={`py-3 ${styles.relatedStoriesItem}`}>
              <a
                href={getUrl(article.name, baseUrl ? baseUrl : rendering.fields?.baseUrl.value)}
                className={`d-flex align-items-center revert-underline ${styles.relatedStoriesLink}`}
              >
                <span className="me-1">
                  {article.articleTitle?.value || article.helpTitle?.value}
                </span>
                <span className={`icon d-flex flex-shrink-0 ms-auto ${styles.icon}`}>
                  <i className="bi bi-chevron-right" style={{ fontSize: '12px' }} aria-hidden />
                </span>
              </a>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default RelatedStories;
